export default __webpack_public_path__ + "static/media/com-nike.5c73dd12.mp4";